import darkSrc from '../assets/virtualclubhousegolf-dark.png';
import { imageLogo } from './imageLogo';

/**
 * Virtual Clubhouse — dark-surface mark: white distressed "VC" + golf ball on
 * transparency, for the branded canvas (/welcome, OTA overlay). White-on-white
 * invisible — never render this on a light surface; the default plate logo
 * (virtualclubhousegolf.tsx) stays the light-surface asset.
 * Source quantized to a 256-color palette PNG (465KB delivery → 50KB).
 */
export const VirtualClubhouseGolfDarkLogo = imageLogo({
  src: darkSrc,
  width: 1000,
  height: 793,
  alt: 'Virtual Clubhouse',
});
